import { render } from "./PanelSection.vue?vue&type=template&id=5a96cd58"
import script from "./PanelSection.vue?vue&type=script&lang=js"
export * from "./PanelSection.vue?vue&type=script&lang=js"

import "./PanelSection.vue?vue&type=style&index=0&id=5a96cd58&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__